export default "__VITE_ASSET__DuOq$1qI__"